import { Button, Card, Input, Label } from "@repo/ui";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export function Compatibility() {
  const nav = useNavigate();
  const [a, setA] = useState("");
  const [b, setB] = useState("");

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!a || !b) return;
    nav(`/compatibility/result?personA=${a}&personB=${b}`);
  }

  return (
    <div className="space-y-6">
      <h1 className="font-display text-3xl">เช็กความเข้ากันได้</h1>
      <Card className="p-6 bg-card/60 max-w-xl">
        <form onSubmit={handleSubmit} className="grid gap-4">
          <div className="grid gap-2">
            <Label htmlFor="a">วัน/เดือน/ปีเกิด คนที่ 1</Label>
            <Input id="a" type="date" value={a} onChange={(e) => setA(e.target.value)} required />
          </div>
          <div className="grid gap-2">
            <Label htmlFor="b">วัน/เดือน/ปีเกิด คนที่ 2</Label>
            <Input id="b" type="date" value={b} onChange={(e) => setB(e.target.value)} required />
          </div>
          <Button type="submit">ดูผล</Button>
        </form>
      </Card>
      <p className="text-sm text-foreground/70">หมายเหตุ: ผลลัพธ์เป็นเพียงแนวทางเพื่อความบันเทิง</p>
    </div>
  );
}

export default Compatibility;
